import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ico ico-bank-update" })
], -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "modal-text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  id: "popover-target-1",
  class: "ico ico-info-popover"
}, null, -1)
const _hoisted_6 = { class: "buttons-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_popover = _resolveComponent("b-popover")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_modal, {
      id: "modal-ExpiredConnection",
      ref: "expiredconnection-modal",
      "hide-header": "",
      "hide-footer": "",
      centered: "",
      "modal-class": "expired-connection-modal",
      modelValue: _ctx.showBankConnectionModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showBankConnectionModal) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.CloseExpireConnectionModal && _ctx.CloseExpireConnectionModal(...args))),
            class: "close"
          }),
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('website.connection-expired')), 1),
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('website.login-again')), 1),
              _hoisted_5
            ]),
            _createVNode(_component_b_popover, {
              target: "popover-target-1",
              triggers: "hover",
              placement: "top",
              "custom-class": "expired-popover"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('website.connection-expired-popover')), 1)
              ], undefined, true),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.CloseExpireConnectionModal && _ctx.CloseExpireConnectionModal(...args))),
              class: "btn btn-outline-dark btn-block me-3 mb-2 mb-sm-0"
            }, _toDisplayString(_ctx.$t('general.no-thanks')), 1),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ConnectBankAccounts && _ctx.ConnectBankAccounts(...args))),
              class: "btn btn-primary btn-block"
            }, _toDisplayString(_ctx.$t('general.connect')), 1)
          ])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modelValue"])
  ]))
}